import { FC } from 'react';

import { Footer, Header, Main } from 'layouts';

import {
  DoctorsBlock,
  FAQBlock,
  HowItWorkBlock,
  IntroContentBlock,
  JoinRevenueProgramBlock,
  PersonalHealthCoachBlock,
  TrustUsBlock,
  UserCommentsBlock,
  WhatIsUpBlock,
} from './content';

export const HomePage: FC = () => {
  return (
    <>
      <Header />
      <Main>
        <IntroContentBlock />
        <WhatIsUpBlock />
        <HowItWorkBlock />
        <PersonalHealthCoachBlock />
        <FAQBlock />
        <TrustUsBlock />
        <UserCommentsBlock />
        <DoctorsBlock />
        <JoinRevenueProgramBlock />
      </Main>
      <Footer />
    </>
  );
};
